import React from 'react'

export const BaggageList = () => {
    return (
        <div>BaggageList</div>
    )
}
